import React from 'react';
import PropTypes from 'prop-types';

// app
import { LogoView } from './Logo.view';
import { ReactComponent as LogoNonPF } from 'assets/svg/logo-vantage.svg';
import { ReactComponent as LogoPF } from 'assets/svg/logo-vantage-pf.svg';
import { ReactComponent as LogoEQX } from 'assets/svg/logo-vantage-eqx.svg';

import { APP_CODE } from 'config/brand';
import { BRAND_PF, BRAND_EQX } from 'config/brand.consts';

Logo.propTypes = {
  height: PropTypes.number,
};

Logo.defaultProps = {
  height: 20,
};

export default function Logo({ height, className, noLink = false }) {
  let logo = LogoNonPF;

  if (APP_CODE === BRAND_PF) {
    logo = LogoPF;
  }
  if (APP_CODE === BRAND_EQX) {
    console.log('LogoEQX');
    logo = LogoEQX;
  }

  return <LogoView component={logo} height={height} noLink={noLink} nestedClasses={className} />;
}
